(function (callback) {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    callback(window, document);
  }
})(function (win, doc) {
  if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    var element = doc.querySelector('meta[name=viewport]');
    if (element) {
      var content = element.getAttribute('content');
      var re = /maximum\-scale=[0-9\.]+/g;
      if (re.test(content)) {
        content = content.replace(re, 'maximum-scale=1.0');
      } else {
        content = [content, 'maximum-scale=1.0'].join(', ');
      }
      element.setAttribute('content', content);
    }
  }
});
